import { Injectable } from '@angular/core'
import { from, Observable } from 'rxjs'
import { BlockDataService } from '../block-services/block-data.service'
import { TemplatesApiService } from 'src/app/builder-services/api/templates.api.service'

@Injectable({
  providedIn: 'root'
})
export class TemplatesService extends BlockDataService {
  constructor(private templatesApi: TemplatesApiService) {
    super()
  }

  /**
   * Fetches all mobile app templates from Supabase.
   * @returns Observable of a record keyed by template UUID.
   */
  getTemplates = (): Observable<Record<string, any>> => {
    return from(this.templatesApi.getMobileTemplates())
  }

  /**
   * Fetches a single mobile app template by UUID.
   * @param id - Template UUID.
   */
  getTemplate = (id: string): Observable<any | null> => {
    return from(this.templatesApi.getMobileTemplate(id))
  }

  /**
   * Creates a new mobile app template.
   * @param name - Template display name.
   * @param image - Preview image URL.
   * @param views - Views/blocks data object.
   * @param category - Template category slug.
   */
  insertTemplate = (name: string, image: string, views: object, category = ''): Observable<{ key: string; response: any } | null> => {
    return from(this.templatesApi.insertMobileTemplate({
      template_name: name,
      template_image: image,
      category,
      views,
    }))
  }

  /**
   * Updates an existing mobile app template.
   * @param id - Template UUID.
   * @param name - Template display name.
   * @param image - Preview image URL.
   * @param views - Views/blocks data object.
   */
  updateTemplate = (id: string, name: string, image: string, views: object): Observable<void> => {
    return from(this.templatesApi.updateMobileTemplate(id, {
      template_name: name,
      template_image: image,
      views,
      updated_at: new Date().toISOString(),
    }))
  }

  /**
   * Deletes a mobile app template by UUID.
   * @param id - Template UUID.
   */
  deleteTemplate = (id: string): Observable<void> => {
    return from(this.templatesApi.deleteMobileTemplate(id))
  }
}
